// --- Header Scroll Class ---

const html = document.querySelector('html');

const header = document.querySelector('#header-wrapper');
const form = document.querySelector('.gform_wrapper');

if (header) {
    document.addEventListener('scroll', function () {
        if (html.scrollTop > 50) {
            header.classList.add('header-scrolled');
        } else {
            header.classList.remove('header-scrolled');
        }
    });
};

if (form) {
    gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj, formId, fieldId) {
        optionsObj.showOtherMonths = false;
        return optionsObj;
    });
};
